import { AutogenModelEdiStatusEvent, AutogenRowEdiStatusEvent } from "./autogen/AutogenModelEdiStatusEvent";

export class ModelEdiStatusEvent extends AutogenModelEdiStatusEvent<RowEdiStatusEvent> {
	constructor() {
		super(RowEdiStatusEvent);
	}
}

export class RowEdiStatusEvent extends AutogenRowEdiStatusEvent {
}